import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdateFundingDocumentMutationRequest, UpdateFundingDocumentMutationResponse, UpdateFundingDocumentQueryParams } from "../../types/UpdateFundingDocument";

/**
     * @link /api/credit-flow-backend/v1/document/do_upload-and-replace
     */
export async function updateFundingDocument (data: UpdateFundingDocumentMutationRequest, params: UpdateFundingDocumentQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<UpdateFundingDocumentMutationResponse>["data"]> {
    const { data: resData } = await client<UpdateFundingDocumentMutationResponse, UpdateFundingDocumentMutationRequest>({
        method: "post",
        url: `/api/credit-flow-backend/v1/document/do_upload-and-replace`,
        params,
        data,
        ...options
    });
    
    return resData;
};